var _defs, _ellipse, _path, _path2, _circle, _circle2, _circle3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _ellipse2, _path15, _path16, _path17, _path18, _ellipse3, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupersmartlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    width: 1024,
    height: 1024,
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 142.485,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(150.286 46.564 88.675)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "23.7%",
    stopColor: "#00fffc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54.5%",
    stopColor: "#00e9fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00d2ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0,
    cy: 0,
    r: 223.469,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(161.745 42.015 91.409)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "23.7%",
    stopColor: "#df1212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54.5%",
    stopColor: "#cf1010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#bf0e0e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 223.469,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(161.745 -.81 93.909)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "23.7%",
    stopColor: "#df1212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54.5%",
    stopColor: "#cf1010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#bf0e0e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 0,
    cy: 0,
    r: 101.936,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(150.255 60.093 88.252)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "23.7%",
    stopColor: "#fff565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54.5%",
    stopColor: "#fff565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fff565"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 0,
    cy: 0,
    r: 144.952,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(150.838 91.798 145.716)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "23.7%",
    stopColor: "#f6af70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54.5%",
    stopColor: "#eb9d59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#df8c42"
  })))), /*#__PURE__*/React.createElement("rect", {
    width: 1034.658,
    height: 1023.998,
    rx: 0,
    ry: 0,
    fill: "#fff",
    x: -5.33,
    style: {
      strokeWidth: 1.45255
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fa9189",
    d: "M512 512 0 0v512z",
    style: {
      fill: "#fcae7c",
      fillOpacity: 1,
      stroke: "#fcae7c",
      strokeOpacity: 1
    },
    transform: "matrix(1.17976 -.07125 .07227 1.1668 -131.406 -47.737)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcae7c",
    d: "M512 512 0 0h512z",
    style: {
      strokeWidth: 0.999615,
      strokeDasharray: "none"
    },
    transform: "matrix(1.17976 -.07125 .07227 1.1668 -131.406 -47.737)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9ffb5",
    d: "M512 512 1024 0v512z",
    style: {
      stroke: "#f9ffb5",
      strokeOpacity: 1
    },
    transform: "matrix(1.17976 -.07125 .07227 1.1668 -131.406 -47.737)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe699",
    d: "M512 512 1024 0H512Z",
    style: {
      fill: "#f9ffb5",
      fillOpacity: 1,
      stroke: "#f9ffb5",
      strokeOpacity: 1
    },
    transform: "matrix(1.17976 -.07125 .07227 1.1668 -131.406 -47.737)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    }
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 74.5,
    ry: 10.5,
    fill: "#f5f5f5",
    transform: "matrix(-2.83358 0 0 3.472 776.755 724.604)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M727.233 558.915s-64.69 88.145-54.044 148.482",
    paintOrder: "stroke fill markers",
    fill: "none",
    stroke: "#000",
    strokeWidth: 16.557,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M989.582 141.578H630.607l-44.632 13.798 34.295 287.733 343.398-10.299z",
    fill: "#be1e2d",
    stroke: "#000",
    strokeWidth: 16.557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 3.875,
    transform: "matrix(-2.51421 0 0 2.51421 728.848 151.503)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 3.875,
    transform: "matrix(-2.51421 0 0 2.51421 814.7 116.243)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 3.875,
    transform: "matrix(-2.51421 0 0 2.51421 946.539 131.573)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M965.708 277.876s10.68-159.811 46.671-224.598c0 0-32.633-20.156-51.351-17.278 0 0-41.751 126.697-46.073 234.68 0 0 24.237 11.515 50.753 7.196M623.527 48.603s57.591 127.991 41.754 278.152c0 0-18.715 8.637-41.754 0 0 0-.72-156.93-49.31-259.15 0 0 24.715-24.866 49.31-19.002",
    fill: "#f7941d",
    stroke: "#000",
    strokeWidth: 16.557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M912.676 20.64s44.632 119.501 0 208.763c0 0-42.83 2.88-57.23-10.078 0 0 47.514-79.184 0-191.485 0 0 31.075-19.719 57.23-7.2M626.378 262.097s46.74-110.76 28.459-206.173c0 0 20.966-16.143 54.089-1.203 0 0 4.702 153.533-36.431 229.35 0 0-41.042 2.205-46.117-21.974",
    fill: "#f7941d",
    stroke: "#000",
    strokeWidth: 16.557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M850.507 71.512s27.355-2.875 47.51 11.521c0 0-31.792 111.887-5.877 187.859 0 0-40.35 20.72-52.508-7.263 0 0-10.72-78.378 10.875-192.117M748.464 100.17s-37.841-15.884-58.91 2.566c0 0-13.196 170.278 45.234 276.118 0 0 42.231 9.485 52.309-12.379 0 0-51.59-147.697-38.633-266.305",
    fill: "#f7941d",
    stroke: "#000",
    strokeWidth: 16.557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M825.479 44.455s41.872 147.095-2.76 236.357c0 0-45.59 2.88-59.989-10.078 0 0 50.273-106.778 2.76-219.08 0 0 32.645-15.874 59.989-7.199",
    fill: "#f7941d",
    stroke: "#000",
    strokeWidth: 16.557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M804.653 130.797s-29.033-18.773-58.427 0c0 0 5.317 130.649-19.96 190.61 0 0 25.357 25.456 62.79 8.875 0 0 16.797-74.283 15.597-199.485",
    fill: "#f7941d",
    stroke: "#000",
    strokeWidth: 16.557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.913-82.174c0 22.043-17.869 39.913-39.913 39.913s-39.913-17.87-39.913-39.913h-20.565l10 164.348 91.956-8 19-156.348z",
    fill: "url(#a)",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      fill: "url(#a)"
    },
    transform: "matrix(-2.7595 0 0 2.7595 752.867 387.656)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-3.652 69.674 21.304 15-10-164.348-25.304-5z",
    fill: "url(#b)",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      fill: "url(#b)"
    },
    transform: "matrix(-2.7595 0 0 2.7595 940.871 380.758)"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M745.845 396.242a13.797 13.797 0 1 0 27.595 0 13.797 13.797 0 0 0-27.595 0m-82.662 0a13.797 13.797 0 1 0 27.595 0 13.797 13.797 0 1 0-27.595 0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M694.886 427.555c0 22.062 46.072 19.363 46.072 0m86.404 131.622s9.948 98.614 54.043 148.482",
    paintOrder: "stroke fill markers",
    fill: "none",
    stroke: "#000",
    strokeWidth: 16.557,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M299.105 617.345s123.615-111.207 67 61.361",
    paintOrder: "stroke fill markers",
    fill: "none",
    stroke: "#000",
    strokeWidth: 16.934,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    style: {
      display: "inline"
    },
    transform: "rotate(-3.998 1118.98 -139.008)scale(.82105)"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M387.447 217.216c2.023 28.935-71.668 57.654-164.589 64.148-92.919 6.495-169.885-11.695-171.907-40.63s71.666-57.653 164.584-64.147c92.922-6.494 169.89 11.694 171.912 40.63",
    fill: "#00b6d8",
    stroke: "#000",
    strokeWidth: 13.904,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M126.729 140.024c.848 12.129-8.296 22.648-20.426 23.495s-22.647-8.297-23.495-20.425 8.296-22.649 20.426-23.496 22.647 8.297 23.495 20.426m32.059 75.745c-12.936.904-22.779 12.225-21.875 25.162l-1.85-26.46c-.903-12.935-12.225-22.778-25.162-21.874s-22.779 12.226-21.874 25.162l10.155 145.308c.904 12.936 12.229 22.779 25.162 21.875 12.937-.904 22.78-12.226 21.876-25.162l1.849 26.456c.904 12.936 12.226 22.78 25.162 21.875s22.78-12.226 21.875-25.162l-10.155-145.305c-.905-12.936-12.226-22.78-25.163-21.875M322.7 136.227q0 0 0 0c-12.936.904-22.779 12.23-21.875 25.165l2.887 41.295c-.905-12.936-12.227-22.778-25.163-21.874-12.268.857-21.736 11.091-21.911 23.18l-1.737-24.858c-.905-12.936-12.226-22.777-25.16-21.873-12.937.905-22.782 12.225-21.878 25.161l10.156 145.31c.904 12.933 12.228 22.776 25.164 21.872 12.266-.857 21.737-11.09 21.912-23.178l1.737 24.852c.904 12.936 12.226 22.781 25.16 21.877 12.936-.904 22.78-12.229 21.875-25.164l-2.886-41.293c.904 12.933 12.226 22.777 25.162 21.872s22.78-12.225 21.875-25.16l-10.155-145.308c-.904-12.935-12.227-22.781-25.163-21.877",
    fill: "#8e5a2d",
    stroke: "#000",
    strokeWidth: 13.904,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0-51.364c-40.196 0-72.782-10.146-72.782-22.663V51.364c0 12.517 32.586 22.663 72.782 22.663 40.197 0 72.783-10.146 72.783-22.663V-74.027C72.783-61.51 40.197-51.364 0-51.364",
    fill: "url(#c)",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "rotate(-3.997 5847.08 -3111.459)scale(2.31728)",
    style: {
      fill: "url(#c)"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m80.989 458.956-28.825 2.014c-28.986 2.026-54.123-19.826-56.15-48.813s19.828-54.12 48.815-56.146l28.824-2.014c8.82-.617 15.289-10.907 14.445-22.983s-8.68-21.366-17.502-20.75l-28.824 2.015c-53.138 3.713-93.202 49.8-89.489 102.935 3.714 53.138 49.8 93.205 102.938 89.491l28.824-2.015c8.821-.616 15.29-10.906 14.445-22.985-.844-12.076-8.68-21.365-17.501-20.749",
    fill: "#00d7ff",
    stroke: "#000",
    strokeWidth: 13.904,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M274.558 377.282a11.587 11.587 0 1 1-23.117 1.616 11.587 11.587 0 0 1 23.117-1.616m69.249-4.84c.446 6.385-4.365 11.92-10.75 12.365a11.587 11.587 0 1 1-1.616-23.116 11.585 11.585 0 0 1 12.366 10.751"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M321.589 407.515c.803 11.49-7.86 21.455-19.35 22.258s-21.456-7.859-22.26-19.35l-.877-12.55 41.61-2.908z",
    fill: "#f1f2f2",
    stroke: "#000",
    strokeWidth: 13.904,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 1024.007,
    height: 516.327,
    rx: 0,
    ry: 0,
    transform: "rotate(-4)",
    fill: "#fff",
    x: -36.963,
    y: 542.234,
    style: {
      strokeWidth: 1.02612
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b3f5bc",
    d: "m512 512 512 512V512Z",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    },
    transform: "matrix(1.17976 -.07125 .07227 1.1668 -131.406 -47.737)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d6f6ff",
    d: "m512 512 512 512H512Z",
    style: {
      fill: "#b3f5bc",
      fillOpacity: 1,
      stroke: "#b3f5bc",
      strokeOpacity: 1,
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    },
    transform: "matrix(1.17976 -.07125 .07227 1.1668 -131.406 -47.737)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e2cbf7",
    d: "M512 512 0 1024h512z",
    style: {
      fill: "#d1bdff",
      fillOpacity: 1,
      stroke: "#d1bdff",
      strokeWidth: 0.999615,
      strokeDasharray: "none",
      strokeOpacity: 1,
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    },
    transform: "matrix(1.17976 -.07125 .07227 1.1668 -131.406 -47.737)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d1bdff",
    d: "M512 512 0 1024V512Z",
    style: {
      display: "inline",
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    },
    transform: "matrix(1.17976 -.07125 .07227 1.1668 -131.406 -47.737)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "m476.364-27.224 71.272 1078.448m533.247-574.779-1137.766 71.11",
    style: {
      strokeWidth: 15,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m525.133 497.381-561.308 57.515",
    style: {
      strokeWidth: 13.9177,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1059.665 477.187-564.294 49.76",
    style: {
      strokeWidth: 12.48,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.09 528.044 483.55-36.124",
    style: {
      strokeWidth: 12,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m541.27 1059.227-44.25-564.128",
    style: {
      strokeWidth: 12.2386,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    }
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 74.5,
    ry: 10.5,
    fill: "#f5f5f5",
    transform: "matrix(2.61887 0 0 3.51528 284.642 1225.045)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M313.432 1070.508s67.443 83.788 52.893 145.324m-162.692-493.61s-13.58-72.292-61.459-108.614",
    paintOrder: "stroke fill markers",
    fill: "none",
    stroke: "#000",
    strokeWidth: 16.205,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M185.794 670.23s2.371-133.924 140.013-138.89c0 0 8.16 117.72-140.013 138.89m3.419 8.688s-56.19-67.935-129.053-13.996c0 0 44.122 63.922 129.053 13.996",
    fill: "#8dc63f",
    stroke: "#000",
    strokeWidth: 16.205,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-3.645-76.751c-.017-.066-.026-.132-.044-.198-1.618-5.762-7.6-9.121-13.362-7.505l-16.054 4.505c-5.763 1.617-9.123 7.599-7.506 13.362.055.198.13.387.195.581-29.608 17.492-44.951 53.336-35.033 88.005 11.463 40.064 53.234 64.071 93.611 53.763 42.301-10.801 67.204-54.217 55.473-96.015-9.853-35.114-42.38-57.734-77.28-56.498z",
    fill: "url(#d)",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    style: {
      fill: "url(#d)"
    },
    transform: "translate(266.571 924.11)scale(2.70077)"
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M312.509 907.224a13.504 13.504 0 1 1-27.008 0 13.504 13.504 0 0 1 27.008 0m80.907 0a13.504 13.504 0 1 1-27.008 0 13.504 13.504 0 0 1 27.008 0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M362.386 937.87c0 21.593-45.092 18.949-45.092 0m-78.472 132.522s-9.282 100.204-52.894 145.325",
    paintOrder: "stroke fill markers",
    fill: "none",
    stroke: "#000",
    strokeWidth: 16.205,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    }
  }, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 74.5,
    ry: 10.5,
    fill: "#f5f5f5",
    transform: "matrix(-3.36338 0 0 3.74084 881.774 1227.933)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m841.413 1110.374-26.667 99.523",
    paintOrder: "stroke fill markers",
    fill: "none",
    stroke: "#000",
    strokeWidth: 14.628,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.001-113.921c-62.917 0-113.922 51.005-113.922 113.922S-66.993 113.921.001 113.921c72.311 0 113.92-51.004 113.92-113.92S62.917-113.921.001-113.921z",
    fill: "url(#e)",
    style: {
      fill: "url(#e)"
    },
    transform: "scale(-2.438 2.438)rotate(.998 -20454.67 -20363.424)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-19.999 45.615c-16.569 0-30-16.655-30-37.2s13.431-37.2 30-37.2C-3.431-28.785 10-12.13 10 8.415s-13.431 37.2-29.999 37.2z",
    fill: "none",
    style: {
      fill: "#b3f5bc",
      fillOpacity: 1
    },
    transform: "scale(-2.438 2.438)rotate(.998 -20454.67 -20363.424)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m923.55 1110.634 26.667 99.524",
    paintOrder: "stroke fill markers",
    fill: "none",
    stroke: "#000",
    strokeWidth: 14.628,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M894.64 618.003q0 0 0 0c8.132-.142 14.668-6.908 14.527-15.04l-.449-25.753c-.141-8.132-6.91-14.668-15.042-14.527s-14.668 6.91-14.526 15.042l.448 25.754c.142 8.132 6.91 14.665 15.042 14.524",
    fill: "#27aae1",
    stroke: "#000",
    strokeWidth: 14.628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M725.569 653.695q0 0 0 0c6.346-5.084 7.38-14.439 2.295-20.785l-16.104-20.1c-5.085-6.348-14.44-7.38-20.788-2.298-6.346 5.088-7.38 14.44-2.296 20.788l16.105 20.1c5.084 6.346 14.439 7.38 20.788 2.295",
    fill: "#fbb040",
    stroke: "#000",
    strokeWidth: 14.628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1003.84 755.031q0 0 0 0c5.474 6.015 14.877 6.459 20.892.985l19.052-17.335c6.012-5.474 6.456-14.874.982-20.89s-14.875-6.458-20.89-.984l-19.049 17.335c-6.015 5.474-6.46 14.874-.987 20.89",
    fill: "#ee2a7b",
    stroke: "#000",
    strokeWidth: 14.628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M943.204 674.08q0 0 0 0c3.853 7.16 12.869 9.866 20.029 6.01l22.68-12.208c7.161-3.856 9.867-12.869 6.011-20.029-3.853-7.162-12.866-9.866-20.026-6.01l-22.683 12.209c-7.16 3.855-9.866 12.868-6.01 20.029",
    fill: "#fbb040",
    stroke: "#000",
    strokeWidth: 14.628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M817.306 671.392q0 0 0 0c7.415-3.34 10.751-12.14 7.413-19.556l-10.58-23.484c-3.342-7.416-12.142-10.75-19.555-7.411s-10.749 12.14-7.41 19.555l10.579 23.488c3.343 7.415 12.14 10.749 19.553 7.408",
    fill: "#ee2a7b",
    stroke: "#000",
    strokeWidth: 14.628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M934.368 701.609q0 0 0 0c-7.424-3.319-16.215.041-19.533 7.468l-10.51 23.515c-3.318 7.427.042 16.217 7.466 19.533s16.217-.04 19.535-7.467l10.51-23.516c3.315-7.427-.044-16.215-7.468-19.533",
    fill: "#27aae1",
    stroke: "#000",
    strokeWidth: 14.628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M784.872 755.367a12.19 12.19 0 0 0 12.4 11.976 12.19 12.19 0 1 0-.424-24.376 12.19 12.19 0 0 0-11.976 12.4m-72.875 1.273a12.19 12.19 0 1 0 24.376-.424 12.19 12.19 0 0 0-24.376.425"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M739.071 792.06c.256 14.703 40.955 13.994 40.699-.71",
    paintOrder: "stroke fill markers",
    fill: "none",
    stroke: "#000",
    strokeWidth: 14.628,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupersmartlogo);
export default __webpack_public_path__ + "static/media/supersmartlogo.a4ea9b9f382c676f495f7f7bca6f41ca.svg";
export { ForwardRef as ReactComponent };